/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Setclipsettings2Inputs */

const en_entity_setclipsettings2 = /** @type {(inputs: Entity_Setclipsettings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Clip Settings`)
};

const de_entity_setclipsettings2 = /** @type {(inputs: Entity_Setclipsettings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clip-Einstellungen setzen`)
};

/**
* | output |
* | --- |
* | "Set Clip Settings" |
*
* @param {Entity_Setclipsettings2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_setclipsettings2 = /** @type {((inputs?: Entity_Setclipsettings2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Setclipsettings2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_setclipsettings2(inputs)
	return de_entity_setclipsettings2(inputs)
});
export { entity_setclipsettings2 as "entity_setClipSettings" }